/* istanbul ignore file */

import { ServiceRequestResponse } from '.';

export class HelpFeedbackServiceModel {
    responseLoading = false;
    serviceResponse: ServiceRequestResponse;
}
